import styled from "styled-components";
import { spacing, typography, colors } from "../../../../../../styles/theme";

export const QuantitySelectorContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spacing("1")};
  align-items: center;
`;

export const SelectWrapper = styled.div`
  min-width: 0;
`;

export const UnavailableText = styled.span`
  font-size: ${typography("caption1.fontSize")};
  color: ${colors("neutral.base")};
`;